import { motion } from "framer-motion";
import { MathRichText } from "@/lib/mathRichText";

interface Props {
  data: { type: "text"; content: string; animation?: string };
  isChildTheme?: boolean;
}

export function ElementText({ data, isChildTheme }: Props) {
  const child = !!isChildTheme;
  return (
    <motion.div
      className={
        child
          ? "lp-text-child text-center py-3 px-4 rounded-2xl border border-white/30 bg-white/15 backdrop-blur-md text-white shadow-inner"
          : "text-center py-2 px-4 rounded-lg border-2 border-indigo-300 bg-indigo-50/50 text-slate-800"
      }
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
    >
      <div className={child ? "lp-text leading-snug" : "text-sm md:text-base"}>
        <MathRichText
          text={data.content}
          highlightVocab
          isChild={child}
          childTheme={child}
        />
      </div>
    </motion.div>
  );
}
